<template>
	<div>
		<p class="tit">视频记录</p>
		 <el-table  :data="tableData" border style="width: 80%;margin: 0 auto;">
			<el-table-column  prop="sender" label="参与人" width="220" align="center">
				<span></span>
			</el-table-column>
			<el-table-column  prop="sendTime"  label="发送时间"  width="260" align="center"  vertical-align="middle">
			</el-table-column>
			<el-table-column  label="时长" align="center">
				<template slot-scope="scope">
					<div class="video">
						<img src="./img/video.png" />
						<span>12:56:56</span>
						<a href="" download="视频文件">下载</a>
					</div>
				</template>
			</el-table-column>				
		</el-table>
	</div>
</template>

<script>
	import { getVideoList } from '@/views/axios/api.js'
	export default {
	  data() {
	    return {
			tableData:[{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'1',
				sendContent:'wenziwenzi'
			},
			{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'2',
				sendContent:'http://api.dev.dajiuxing.com.cn/p3/a/2019/0523/1020/40bad644_96f083bf04a196_0.png'
			},
			{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'3',
				time:'3',
				gifShow:false,
				sendContent:'http://api.dev.dajiuxing.com.cn/a3/a/2019/0509/0939/fc1131dc_92a225788b25a1_src.amr.mp3'
			},
			
			],
			caseid:''
	    }
	  },
	  methods: {
	    onSubmit() {
	      console.log('submit!');
	    },
		startPlay(row){			
			this.$refs.audioBox.play();
			row.gifShow=true;			
			setTimeout(()=>{
				row.gifShow=false;
			},row.time * 1000)
		},
		getData(){
			var data={
// 				caseid:this.caseid,
// 				count:1000,
// 				start:0,
			}
			getVideoList()
			.then(res => {
				console.log(res);
				
			})
			.catch( err => {
				console.log(err)
			})
		}
	  },
	  mounted() {
	  	this.getData()
		this.caseid=this.$route.query.caseid;
	  }
	}
</script>

<style scoped>
	.tit{
		font-size: 22px;
		color: #333;
		width: 100%;
		text-align: center;
		margin-top: 70px;
		margin-bottom: 40px;
	}
	
	.video img{
		width: 30px;
		vertical-align: middle;

	}
	.video span{
		padding-right: 50px;
		padding-left: 10px;
	
		color: #00ABFA;
		
	}
	.video a{
		color: #00ABFA;
		cursor: pointer;
		text-decoration: none;
	}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/videoList.vue